var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2784_1831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.23432 7.36754L6.43432 10.7522C6.74677 11.0826 7.25326 11.0826 7.56569 10.7522L10.7657 7.36755C11.0781 7.0371 11.0781 6.50135 10.7657 6.1709C10.4533 5.84045 9.94673 5.84045 9.63431 6.1709L7.79999 8.11105L7.79999 0.846155C7.79999 0.37884 7.44181 6.42608e-07 6.99999 6.03982e-07C6.55817 5.65357e-07 6.19999 0.37884 6.19999 0.846155L6.19999 8.11105L4.3657 6.17092C4.20947 6.00569 4.00475 5.92308 3.8 5.92308C3.59525 5.92308 3.39052 6.00569 3.2343 6.17092C2.9219 6.50137 2.9219 7.03712 3.2343 7.36757L3.23432 7.36754Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14H3.5C1.57008 14 0 12.4299 0 10.5V7.875C0 7.39175 0.391754 7 0.875 7C1.35825 7 1.75 7.39175 1.75 7.875V10.5C1.75 11.465 2.53504 12.25 3.5 12.25H10.5C11.465 12.25 12.25 11.465 12.25 10.5V7.875C12.25 7.39175 12.6418 7 13.125 7C13.6082 7 14 7.39175 14 7.875V10.5C14 12.4299 12.4299 14 10.5 14Z",
    fill: "#353535"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2784_1831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.55fbe9f7d9e63943c0dd5e68b82c29a7.svg";
export { ForwardRef as ReactComponent };